import { FIELD_OFFICER_ROLE_ENUM } from "./StringConstant"

export const RoutesConstants = {
  FIELD_OFFICER: {
    ASSIGN_MITRA: () => `/field-officer/assign/mitra`,
    EDIT_FO: (id) => `/field-officer/edit/${id}`,
    CREATE_FO: () => `/field-officer/new`,
    LIST_FO_AGRONOMIS: (tab) =>
      `/field-officer/${FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_AGRONOMIST}/${tab}`,
    DETAIL_FO_AGRONOMIS: (role, id) => `/field-officer/${role}/list-fo/${id}`,
    LIST_FO: (role) => `/field-officer/${role}/list`,
    LIST_FO_QA: (tab) => `/field-officer/${FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_QA}/${tab}/list`,
    DETAIL_FO_QA: (role, tab, id) => `/field-officer/${role}/${tab}/list/detail/${id}`,
    DETAIL_FO: (role, id) => `/field-officer/${role}/detail/${id}`,
    EDIT_FO_QA: (role, tab, id) => `/field-officer/${role}/${tab}/edit/${id}`,
    EDIT_TEAM_DRONE: (action, id) =>
      `/field-officer/${FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_AGRONOMIST}/team/${action}/${id}`,
    CREATE_TEAM: (action) =>
      `/field-officer/${FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_AGRONOMIST}/team/${action}`,
    DETAIL_FO_AGRONOMIST_TEAM: (id) => `/field-officer/agronomist/team/detail/${id}`,
    FORM_ASSIGN_OPS_ADMIN: () => `/field-officer/assign/assign-ops-admin/create`,
    OPS_ADMIN_REGIONAL: (regional) => `/field-officer/ops-admin/regional/${regional}`,
    LIST_REGIONALS_OPS_ADMIN: () => `/field-officer/ops-admin/regionals`,
    KPI_GOAL_SETTING: (regionalId, tabs, year) => `/field-officer/kpi-goal-setting/${regionalId}/${tabs}` + (year ? "/" + year : ''),
    KPI_GOAL_SETTING_INDEX: () => `/field-officer/kpi-goal-setting`,
    CREATE_SETTING_TARGET_FORM: (regional) => `/field-officer/target/setting/${regional}`,
    EDIT_TARGET_REGIONAL: (year, regional) => `/field-officer/target/regional/${regional}/edit/${year}`,
    EDIT_TARGET_SUBREGIONAL: (year, regional) => `/field-officer/target/subregional/${regional}/edit/${year}`,
    DETAIL_KPI_TARGET_KPI_BY_YEAR: (year, regional) => `/field-officer/target/regional/${regional}/detail/${year}`,
    SETTING_FORECAST: () => `/field-officer/forecast/setting`,
    FORECAST_SUBREGIONAL: (id, year, regional) => `/field-officer/forecast/${regional}/subregional/${id}/${year}`,
  },
  ORDER: {
    LIST_PASCA_PLANTING_BY_STATUS: (status) => `/order/pasca-planting/${status}`,
    LIST_PRE_PLANTING_BY_STATUS: (status) => `/order/pre-planting/${status}`,
    DETAIL_PASCA_PLANTING: (status, id) => `/order/pasca-planting/${status}/${id}`,
    DETAIL_PRE_PLANTING: (status, id) => `/order/pre-planting/${status}/${id}`,
    LIST_BY_STATUS: (status) => `/order/list/${status}`,
    LIST_PENDING_BY_TAB: (tab) => `/order/list/pending/${tab}`,
    DETAIL: (status, id) => `/order/detail/${status}/${id}`,
    APPROVAL: (status, id) => `/order/approval/${status}/${id}`,
    APPROVAL_PASCA_TANAM: (status, id) => `/order/pasca-planting/approval/${status}/${id}`,
    APPROVAL_PRE_PLANTING: (status, id) => `/order/pre-planting/approval/${status}/${id}`,
    APPROVAL_BULK: (planting) => `/order/pending/approval/bulk/${planting}`,
    APPROVAL_BULK_PASCA_TANAM: () => `/order/pasca-planting/approve/bulk`,
    APPROVAL_BULK_PRE_PLANTING: () => `/order/pre-planting/approve/bulk`,
    RESCHEDULE_BULK_PASCA_PLANTING: () => `/order/reschedule/bulk`
  },
  FARMER: {
    LIST_FARMER_TERVERIFIKASI: (tab) => `/farmer/terverifikasi/${tab}`,
    DETAIL_FARMER: (status, id) => `/farmer/list/${status}/${id}`,
    LIST_FARMER_CA: () => `/farmer/list-ca/list`,
    LIST_FARMER: (tab) => `/farmer/list/${tab}`,
    CREATE: () => `/farmer/action/new`,
    EDIT_FARMER_STATUS: (status, id) => `/farmer/action/${status}/edit/${id}`,
    EDIT_FARMER: (id) => "/farmer/action/edit/" + id
  },
  MITRA: {
    DETAIL_MITRA: (status, id) => `/mitras/list/${status}/${id}`,
    LIST_MITRA: (status) => `/mitras/list/${status}`,
    CREATE: () => `/mitras/action/new`,
    LIST_MITRA_KUR: () => `/mitras/list-kur/list`,
    EDIT_MITRA: (status, id) => `/mitras/action/${status}/edit/${id}`
  },
  AREA: {
    LIST_AREA_TEREGISTRASI: (status) => `/lahan/list-teregistrasi/${status}`,
    DETAIL_AREA: (status, id) => `/lahan/list/${status}/${id}`,
    LIST_AREA_ACTIVITY: (tab) => `/lahan/activity-list/${tab}`,
    LIST_AREA_ACTIVITY_KUR: () => `/lahan/activity-kur`,
    LIST_AREA_ACTIVE: () => `/lahan/list/active`,
    LIST_AREA_UNASSIGNED: (status) => `/lahan/list-unassign/${status}`,
    LIST_PENDING: () => `/lahan/list/pending`,
    LIST_AREA_STATUS: (status) => `/lahan/list/${status}`,
    LIST_SO: (tab) => `/lahan/sales-order/${tab}`,
    DETAIL_SO: (id) => `/lahan/so/detail/${id}`,
    DETAIL_SPK: (id) => `/lahan/spk/detail/${id}`,
    FORM_FAILED_HARVEST: (id) => `/lahan/failed-harvest/${id}`,
    DETAIL_ACTIVITY: (areaId, activity, activityId) =>
      `/lahan/active-mt/${areaId}/${activity}/${activityId}`,
    PREVIEW_BULK_ERP: () => `/lahan/activity-list/bulk/preview`,
    DETAIL_AREA_PENDING_UNASSIGN: (status, id) => `/lahan/list/${status}/${id}/pending-unassigned`,
    DETAIL_HISTORY_ACTIVITY: (status, areaId, id) =>
      `/lahan/list/${status}/${areaId}/history-activity/${id}`,
    DETAIL_ACTIVITY_SEEDLING: (status, id, activityId) =>
      `/lahan/${status}/${id}/seedling/${activityId}`,
    DETAIL_ACTIVITY_TILLAGE: (status, id, activityId) =>
      `/lahan/${status}/${id}/tillage/${activityId}`,
    DETAIL_ACTIVITY_PLANTING: (status, id, activityId) =>
      `/lahan/${status}/${id}/planting/${activityId}`,
    DETAIL_ACTIVITY_LAND_CLEARING: (status, id, activityId) =>
      `/lahan/${status}/${id}/land-clearing/${activityId}`,
    DETAIL_ACTIVITY_TYPE_CUSTOM: (status, id, type, activityId) =>
      `/lahan/${status}/${id}/${type}/${activityId}`,
    DETAIL_AREA_LEAD: (id) => `/lahan/list/lead/${id}`,
    DETAIL_AREA_UNASSIGNED: (status, id) => `/lahan/list-unassign/${status}/${id}`,
    EDIT_AREA: (id) => "/area/action/edit/" + id,
    LIST_AREA_READY_PLANTING_SEASON_CONFIRMATION: (tab) => `/lahan/ready-planting-season-confirmation/${tab ? tab : ''}`,
    LIST_BLOCK: (status) => `/lahan/block/${status}`,
    DETAIL_BLOCK: (status, id) => `/lahan/block/${status}/${id}`,
    DETAIL_QA_INSPECTION: (status, id, activityId) =>
      `/lahan/${status}/${id}/qa-inspection/${activityId}`,
    SEND_PLANTING_SESSION_REPORT: (id) => `/lahan/send-planting-session-report/${id}`,
  },
  MAC: {
    LIST_PROFILE: () => `/mac/profile`,
    PROFILE_DETAIL: (id) => `/mac/profile/${id}`,
    LIST_SPRAYING: (tab) => `/mac/spraying/${tab}`,
    LIST_USER: () => `/mac/user`,
    USER_DETAIL: (id) => `/mac/user/${id}`,
    ACTIVITY_REPORT_LIST: () => `/mac/activity-report`,
    DETAIL_ACTIVITY_REPORT: (id) => `/mac/activity-report/detail/${id}`,
    SPRAYING_DETAIL: (status, id) => `/mac/spraying/${status}/${id}`,
    MAC_SPRAYING_APPROVAL: (status, id) => `/mac/spraying/approval/${status}/${id}`
  },
  MASTER_DATA: {
    REGIONAL: {
      PAGE: () => "/master/regional/list",
      ADD_REGIONAL: () => "/master/regional/new",
      CREATE_SUB_REGIONAL: (id) => `/master/sub-regional/created/${id}`,
      EDIT_SUB_REGIONAL: (id, regionalId) => `/master/sub-regional/edit/${regionalId}/${id}`,
      DETAIL_REGIONAL: (id) => `/master/regional-detail/${id}`,
      EDIT_REGIONAL: (id) => `/master/regional/edit/${id}`
    },
    PACKAGE: {
      PAGE: () => `/master/package`,
      DETAIL: (id) => `/master/package/list/detail/${id}`,
      EDIT: (id) => "/master/package/list/edit/" + id,
      LIST: (id) => "/master/package/list/list/" + id,
      NEW: () => `/master/package/new`
    },
    TREATMENT: {
      NEW: (package_id, plant_type_id, sequence) =>
        `/master/treatment/new/${package_id}/${plant_type_id}/${sequence}`,
      EDIT: (package_id, plant_type_id, sequence, treatment_id) =>
        `/master/treatment/edit/${package_id}/${plant_type_id}/${sequence}/${treatment_id}`
    },
    CATEGORY_ITEM: {
      PAGE: () => "/master/category-item",
      NEW_ITEM: (item) => `/master/category-item/${item}/new`,
      NEW_ITEM_WITH_SUBTYPE: (item, subtype) => `/master/category-item/${item}/new/${subtype}`,
      DETAIL_WITH_SUBTYPE: (type, subtype) => `/master/category-item/detail/${type}/${subtype}`,
      NEW: (type, subtype) => `/master/category-item/${type}/${subtype}`
    },
    MANAGE_REASON: {
      LIST_REASON: () => "/master/manage-reason",
      UNPACKAGE_REASON: () => "/master/manage-reason/unpackage_reason",
      PAGE: (enum_name) => `/master/manage-reason/${enum_name}`
    },
    BASE: {
      LIST: (type) => `/master/base/${type}`,
      DETAIL: (id, tab) => `/master/base/detail/${id}/${tab}`,
      CREATE: () => `/master/base/new`,
      EDIT: (id) => `/master/base/edit/${id}`
    }
  },
  SETTING: {
    CREATE_USER: () => `/account/action/new`,
    LIST_ACCOUNT: () => `/account/list`,
    LIST_EDIT_ACCOUNT: (id) => `/account/list/edit/${id}`,
    EDIT_USER: (id) => `/account/action/edit/${id}`,
    DETAIL_USER: (id) => `/account/list/detail/${id}`
  },
  SUBMISSION: {
    CREATE_SUBMISSION: () => `/submission/create`,
    LIST_SUBMISSION_BY_STATUS: (status) => `/submission/certification-block/${status}`,
    DETAIL_AREA_CERTIFICATION_PENDING: (id) => `/submission/certification-block/pending/${id}`,
    DETAIL_BLOCK_CERTIFICATION: (status, id) => `/submission/certification-block/${status}/${id}`
  },
  REPORT: {
    CREATE_REPORT: () => `/report/create/ba`,
    LIST_BA_SEEDING: () => "/report/list/ba-seeding"
  },
  VIDEO: {
    LIST: () => "/video/list",
    EDIT: (id) => "/video/action/edit/" + id,
    DETAIL: (id) => "/video/detail/" + id,
    CREATE: () => "/video/action/create"
  },
  ROLE: {
    LIST_PAGE: () => "/role/list",
    LIST: (type) => "/role/list" + type,
    SETTING_PRIVILAGE_CMS: (displayName, id) => "/role/action/cms/" + displayName + "/" + id,
    SETTING_PRIVILAGE_FO: (displayName, id) => "/role/action/fo/" + displayName + "/" + id
  },
  AUTH: {
    LOGOUT: () => "/logout",
    EDIT_PASSWORD: () => "/account/edit-password"
  }
}
